<template>
  <div class="order-input" :class="{ disabled: disabled }">
    <ic-input
      :id="id"
      :label="label"
      :placeholder="placeholder"
      :size="size"
      :block="block"
      :currency="trade ? false : true"
      :plain="true"
      :allowBlank="true"
      :trade="trade"
      :disabled="disabled"
      :decimal="decimal"
      :precision="precision"
      @change="change"
      v-model="modelValue"
    />
    <div class="suffix">
      <slot name="suffix" />
    </div>
  </div>
</template>

<script>
import { inputProps } from '../../props'
export default {
  props: inputProps,
  data() {
    return {
      modelValue: '',
      propValue: '',
    }
  },
  watch: {
    modelValue() {
      if (typeof this.modelValue === 'string')
      this.$emit('input', this.modelValue.replace(',', ''))
    },
    value() {
      this.modelValue = this.value
    },
    type() {
      this.modelValue = 0
    },
  },
  methods: {
    change(value) {
      this.modelValue = value
    },
  },
}
</script>

<style lang="scss">
@import './OrderInput.scss';
</style>
